// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".q-dialog__inner--minimized {\n  padding: 0px !important;\n}\n.q-toolbar {\n  min-height: 40px;\n}\n.q-toolbar .q-toolbar__title {\n  font-size: 1.2em;\n  font-weight: 700;\n}\n.full-dialog .q-dialog__inner {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
